import { NotificationTypes } from 'enums/notificationTypes';
import Notification from 'shared/components/Notification';
import { RawMaterialProps } from 'enums/RawMaterialEnums';
import { defaultPackageMaterial } from '../defaultValue';
import { FormikProps } from 'formik';
import { rawMaterialPayload, Origin } from 'views/CreateProductFlow/CreateProductFlowInterfaces';

export const handlePackagingOnChange = (
  value: string,
  index: number,
  formikProps: FormikProps<rawMaterialPayload>
) => {
  const packaging = formikProps.values.packageMaterials;
  const selectedPackaging = packaging.find(
    item => item.packingMaterialName === value
  );
  if (selectedPackaging) {
    Notification({
      message:
        'Packaging Material already exists, please add another sub-origin',
      description: '',
      type: NotificationTypes.ERROR,
    });
    return null;
  }
  formikProps.setFieldValue(
    `${RawMaterialProps.PACKAGE_MATERIAL}.['${index}']`,
    {
      ...defaultPackageMaterial,
      packingMaterialName: value,
      packingMaterialQuantity:
        formikProps.values.packageMaterials[index]?.packingMaterialQuantity ??
        '',
      packingMaterialUnit:
        formikProps.values.packageMaterials[index]?.packingMaterialUnit ??
        undefined,
      numberOfUnitsPerPackingMaterial:
        formikProps.values.packageMaterials[index]
          ?.numberOfUnitsPerPackingMaterial ?? undefined,
    },
    true
  );
};

export const onOriginClick = (
  index: number,
  isDisabled: boolean,
  formikProps: FormikProps<rawMaterialPayload>,
  showLocationModal: (
    index: number,
    type: string,
    selectedIndexData?: Origin[],
    selectedRecordIndex?: number,
    selectedRecordType?: string
  ) => void
) => {
  if (isDisabled) return true;

  const dataObj = [
    {
      address: formikProps?.values?.packageMaterials?.[index]?.address,
      bestfitRegion:
        formikProps?.values?.packageMaterials?.[index]
          ?.packingMaterialbestFitProductionRegion,
      ingredientOrigin:
        formikProps?.values?.packageMaterials?.[index]?.packingMaterialOrigin,
      id: formikProps?.values?.packageMaterials?.[index]?.id,
      originShare: undefined,
      percentage: '%',
    },
  ];
  showLocationModal(
    index,
    RawMaterialProps.PACKAGE_MATERIAL,
    dataObj,
    index,
    RawMaterialProps.PACKAGE_MATERIAL
  );
};